<template>
  <zt-dialog :visible="value" @close="onClose" @closed="onClosed" :modal="modal" :title="'选择抓取' + typeName" :append-to-body="true"
      :modal-append-to-body="false">
    <el-scrollbar>
      <waterfall :line-gap="192" :min-line-gap="20" :watch="imagesList">
        <waterfall-slot
          v-for="(item, index) of imagesList"
          :key="item.id"
          :width="item.width"
          :height="item.height"
          :order="index"
        >
          <div class="waterfall-item" @click="onChooseImage(item, index)">
            <div class="img-box" :class="{ 'is-choose': selectList.includes(item) }">
              <img :src="item.src">
              <!-- <svg-icon icon="correct"/> -->
            </div>
          </div>
        </waterfall-slot>
      </waterfall>
    </el-scrollbar>
    
    <div slot="footer" class="dialog-footer">
      <span class="couter" v-if="multiple">已选择{{this.selectList.length}}张</span>
      <zt-button @click="onClose" class="mr10">取 消</zt-button>
      <zt-button type="primary" @click="onSubmit">确 定</zt-button>
    </div>
  </zt-dialog>
</template>

<script>
import Waterfall from 'vue-waterfall/lib/waterfall'
import WaterfallSlot from 'vue-waterfall/lib/waterfall-slot'

import ZtDialog from '@cps/ZtDialog'

import typeMixin from '../mixins/type'

export default {
  name: 'CaptureDialog',
  mixins: [ typeMixin ],
  components: { ZtDialog, Waterfall, WaterfallSlot },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: { type: Boolean, default: false },

    // 待选
    choices: { type: Array, default: () => [] },

    modal: { type: Boolean, default: true },

    // 多张图片
    multiple: { type: Boolean, default: true },
  },
  data: () => ({
    imagesList: [],
    selectList: [], // 记录选中的item
  }),
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value) this.loadImages()
      },
    },
  },
  methods: {

    // 选图片
    onChooseImage(item) {

      if (!this.multiple) {
        this.selectList = [ item ]
        return
      }

      const index = this.selectList.indexOf(item)
      
      if (index < 0) {
        this.selectList.push(item)
      }
      else {
        this.selectList.splice(index, 1)
      }
    },

    onSubmit() {
      this.$emit('submit', this.selectList)
      this.onClose()
    },

    // 加载多张图片
    async loadImages() {
      if (!this.choices.length) return
      this.imagesList = []

      this.choices.forEach((item) => {
        this.loadImage(item).then((res) => {
          this.imagesList.push({
            src: res.src,
            width: res.image.width,
            height: res.image.height,
          })
        }).catch((res) => {
          this.imagesList.push({
            src: res.src,
            width: res.image.width,
            height: res.image.height,
            isError: true,
          })
        })
      })
    },

    // 加载单张图片
    loadImage(item) {
      return new Promise((resolve, reject) => {
        const image = new Image()
        image.src = item.src
        const result = { ...item, image }
        if (image.complete) {
          resolve(result)
        }
        image.onload = function() {
          resolve(result)
        }
        image.onerror = function() {
          reject(result)
        }
      })
    },


    onClose() {
      this.$emit('input', false)
    },

    onClosed() {
      this.selectList = []
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  height: 400px;
}

.el-scrollbar {
  height: 100%;
   /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}

.vue-waterfall {
  .vue-waterfall-slot {
    padding: 6px;
  }
}

.img-box {
  border-color: #FFF;
  position: relative;
  border: 1px solid $theme-textplaceholder;

  &.is-choose {
    border-color: #FFF;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      border: 2px solid #3ac282;
    }
    &::after {
      content: "";
        position: absolute;
        top: 0;
        right: 0;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 36px 36px 0;
        border-color: transparent #3ac282 transparent transparent;
    }
  }
  
  img {
    width: 100%;
    height: 100%;
    display: block;
    user-select: none;
  }
}

.couter {
  float: left;
  font-size: 12px;
  color: $theme-textsecond;
}


</style>